import { atom } from 'jotai';
import { IProductAvailabilityNotification } from '@/types';

export const productAvailabilityNotificationsAtom = atom<
  IProductAvailabilityNotification[]
>([]);
